import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const TechStackAsAService = () => {
    const navigate = useNavigate();

    // For demonstration, the Learn More buttons currently redirect to Google.
    // Replace this with your actual navigation logic or paths as needed.
    const handleNavigation = () => {
        navigate('/contact');
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Tech Stack as a Service (TStaaS)</h1>
                        <p className="tagline">
                            Accelerate your development process with our curated tech stacks.
                        </p>
                    </header>

                    <section className="introduction">
                        <p>
                            Our TStaaS offering delivers a comprehensive suite of pre-configured technology solutions to jumpstart your projects. Whether you're building a new application or modernizing existing systems, our expert-curated tech stacks provide a robust foundation for innovation, scalability, and competitive advantage.
                        </p>
                    </section>

                    <section className="why-choose-us">
                        <h2>Why Choose TStaaS?</h2>
                        <p>
                            We combine deep technical expertise with extensive industry experience to offer ready-to-deploy technology stacks that are optimized for performance, security, and cost-efficiency. Our solutions reduce development time, lower operational costs, and accelerate time-to-market.
                        </p>
                    </section>

                    <section className="tech-stack">
                        <h2>Our Curated Tech Stacks</h2>
                        <p>
                            Our offerings cover a broad spectrum of development needs, including:
                        </p>
                        <ul>
                            <li><strong>Full-Stack Web Development:</strong> Leverage modern frameworks like React, Angular, and Node.js for dynamic and responsive applications.</li>
                            <li><strong>Mobile & IoT Solutions:</strong> Build robust native or cross-platform apps using Flutter, Swift, Kotlin, and specialized IoT integrations.</li>
                            <li><strong>Cloud & DevOps Integration:</strong> Utilize AWS, Azure, or GCP combined with automated CI/CD pipelines for seamless scalability and reliability.</li>
                            <li><strong>Data, Analytics & AI/ML:</strong> Integrate advanced data processing, predictive analytics, and AI/ML capabilities to drive intelligent insights and automation.</li>
                        </ul>
                    </section>

                    <section className="secure-practices">
                        <h2>Optimized, Secure, & Scalable</h2>
                        <p>
                            Every tech stack we provide is built with the highest standards of security, performance, and scalability in mind. Our solutions adhere to industry best practices and are continuously updated to leverage the latest advancements, including AI-powered enhancements.
                        </p>
                    </section>

                    <section className="services">
                        <h2>Our TStaaS Offerings</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Custom Full-Stack Solutions</h3>
                                <p>
                                    Tailor a full-stack package from design to deployment, customized to your business needs.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Mobile & IoT Stacks</h3>
                                <p>
                                    Empower your mobile and IoT projects with specialized stacks that drive innovation.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Cloud & DevOps Integration</h3>
                                <p>
                                    Accelerate your cloud journey with integrated DevOps practices and automated pipelines.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Data, Analytics & AI/ML Solutions</h3>
                                <p>
                                    Enhance decision-making with robust data processing, advanced analytics, and AI/ML-driven insights.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default TechStackAsAService;
